<!--  -->
<template>
    <div>
        <van-cell-group>
            <van-cell center title="常见问题">
                <template #title>
                    <div class="guide-item flex align-center">
                        <img src="../../assets/images/operationGuide/question.png" alt="" />
                        <p>常见问题</p>
                    </div>
                </template>
            </van-cell>
            <van-cell v-for="item in questionList" :key="item.id" @click="skipDetail(item)" is-link>
                <template #title>
                    <div class="guide-item flex align-center">
                        <div></div>
                        <p>{{ item.title }}</p>
                    </div>
                </template>
            </van-cell>
        </van-cell-group>

        <div class="guide-block"></div>
        <van-cell-group>
            <van-cell center is-link to="/operationGuide/refund">
                <template #title>
                    <div class="guide-item flex align-center">
                        <img src="../../assets/images/operationGuide/refund.png" alt="" />
                        <p>关于退款</p>
                    </div>
                </template>
            </van-cell>
        </van-cell-group>
        <div class="guide-block"></div>
        <van-cell-group>
            <van-cell center title="关于申诉" is-link to="/operationGuide/appeal">
                <template #title>
                    <div class="guide-item flex align-center">
                        <img src="../../assets/images/operationGuide/appeal.png" alt="" />
                        <p>关于申诉</p>
                    </div>
                </template>
            </van-cell>
        </van-cell-group>
    </div>
</template>

<script>
import { zzconfig } from "@/config/zzconfig";
export default {
    name: "Question",
    data() {
        return {
            questionList: [
                {
                    id: 10,
                    title: "收费标准",
                    content: `
                    <p>一、路内（道路泊位）：</p>
                    <p>【收费泊位】：城区道路路内、外公共停车泊位</p>
                    <p>【收费车辆类型】：小型客货车（9人以下含9人或1.8吨以下含1.8吨）。</p>
                    <p>【收费时间】：每天8:00至21:00，其余时间免费</p>
                    <p>【收费标准】：停放半小时内免费，停放30分钟-1小时内（含1小时）每辆次2元，此后每半小时加收1元(不足半小时按半小时计)，同一辆车连续单次停放24小时，最高收费25元。</p>
                    <br/>
                    <p>二、路外（停车场：锦绣公园、植物园、岩山公园）：</p>
                    <p>【收费车辆类型】：小型客货车（9人以下含9人或1.8吨以下含1.8吨）。</p>
                    <p>【收费时间】：24小时全天候</p>
                    <p>【收费标准】：停放1小时内免费，超过1小时后每半小时加收1元（不足半小时按半小时计），同一辆车连续单次停放24小时，最高收费25元。</p>
                    <br/>
                    <p>三、行政服务中心停车场：</p>
                    <p>【收费车辆类型】：小型客货车（9人以下含9人或1.8吨以下含1.8吨）。</p>
                    <p>【收费时间】：24小时全天候</p>
                    <p>【收费标准】：停放2.5小时内免费，停放2小时30分钟-3小时内（含3小时）每辆次2元，此后每半小时加收1元（不足半小时按半小时计），同一辆车连续单次停放24小时，最高收费25元。</p>
                `,
                },
                {
                    id: 0,
                    title: "车位使用流程",
                    content: `
                    <p>1）【入场扫码】车辆驶入车位后，系统开始计时，车主须在5分钟内用“微信·扫一扫”扫车位前方或侧方服务二维码；也可进入【泉港智慧停车】服务号底部【停车缴费】菜单选择“扫码停车”或输入6位车位编号，按提示确认停车。</p>
                    <p>2）【缴费离场】当您取车前，请再一次通过“微信·扫一扫”完成扫车位前方或侧方服务二维码即可完成缴费；也可进入【泉港智慧停车】服务号底部【停车缴费】菜单输入地面上标识的6位数的编号即可完成缴费。</p>
                `,
                },
                {
                    id: 1,
                    title: "如何进行车辆绑定、车辆认证和实名认证？",
                    content: `
                    
                    <p>【车辆绑定】：</p>
                    <p>进入“泉港智慧停车”公众号，点击【个人中心】模块，点击【我的车辆】进行绑定。</p>
                    <p>【车辆认证】：</p>
                    <p>进入“泉港智慧停车”公众号，点击【个人中心】模块，点击【我的车辆】在已绑定车辆的基础上，上传行驶证主副页照片进行车辆认证，提交后等待工作人员审核，审核通过即可完成认证。</p>
                    <p>【实名认证】：</p>
                    <p>进入“泉港智慧停车”公众号，进入“泉港智慧停车”公众号，点击【个人中心】模块，点击【个人设置】进入个人信息页面，点击【实名认证】进入到实名认证页面，上传身份证照片进行实名认证，提交后即成功认证。</p>

                    `,
                },
                {
                    id: 2,
                    title: "如何查看过往停车记录？",
                    content: `<p>进入“泉港智慧停车”公众号首页，点击【停车记录】查看停车记录。</p>`,
                },
                {
                    id: 3,
                    title: "我的停车记录显示欠费/未缴费，如何线上补缴？",
                    content: `
                    <p>进入“泉港智慧停车”公众号首页，点击【欠费补缴】，进入欠费补缴页面可查看待缴费情况并进行欠费补缴。</p>

                    `,
                },
                {
                    id: 4,
                    title: "我如何开取电子发票？",
                    content: `<p>进入“泉港智慧停车”公众号，点击【个人中心】模块——点击【电子发票】，进入电子发票页面，点击【停车缴费开票】，选择停车记录进入发票信息填写页面，提交信息即可完成开票。</p>
注：如需开具电子发票，需先注册绑定车牌，再进行停车缴费，才能开具发票。
`,
                },
                {
                    id: 5,
                    title: "如何使用优惠券？",
                    content: `当您的车辆产生停车费用后，在缴费期间，可选择相应可用的优惠券完成付款。`,
                },
                {
                    id: 6,
                    title: "如何获取就近停车场信息？",
                    content: `进入“泉港智慧停车”公众号，点击【我要停车】模块，输入出行目的地，获取就近停车场信息，点击具体停车场所进行【导航】。`,
                },

                {
                    id: 7,
                    title: "车主缴费时显示的不是自己的车牌号，怎么办？",
                    content: `<p>1、请在【客服帮助】页面，点击【投诉建议】，填写问题，工作人员会在三个工作日内处理您的问题。</p>
<p>2、可在停车现场向巡检人员反馈问题，有巡检人员协助处理</p>
<p>3、请拨打客服电话：「${zzconfig.PHONE}」进行问题反馈</p>
`,
                },

                {
                    id: 8,
                    title: "车主缴费时入位时间不对，金额不对，怎么办？",
                    content: `<p>1、请在【客服帮助】页面，点击【投诉建议】，填写问题，工作人员会在三个工作日内处理您的问题。</p>
<p>2、可在停车现场向巡检人员反馈问题，有巡检人员协助处理</p>
<p>3、请拨打客服电话：「${zzconfig.PHONE}」进行问题反馈</p>
`,
                },
                {
                    id: 9,
                    title: "为什么我的停车费这么多？",
                    content: `<p>1、请在【客服帮助】页面，点击【投诉建议】，填写问题，工作人员会在三个工作日内处理您的问题。</p>
<p>2、可在停车现场向巡检人员反馈问题，有巡检人员协助处理</p>
<p>3、请拨打客服电话：「${zzconfig.PHONE}」进行问题反馈</p>
`,
                },
            ],
        };
    },

    components: {},

    computed: {},

    mounted() {},

    methods: {
        //跳转到指南详情
        skipDetail(item) {
            this.$router.push({
                name: "operationGuideDetail",
                params: item,
            });
        },
    },
};
</script>
<style lang="less" scoped>
.guide-block {
    height: 16px;
}
.guide-item {
    div {
        width: 32px;
        height: 32px;
    }

    img {
        width: 32px;
        height: 32px;
    }
    p {
        font-size: 28px;
        color: #333333;
        margin-left: 17px;
    }
}
</style>
